/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi_card__image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Attraktive Gegend`
};

const en_zoi_card__image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Area of interest`
};

const es_zoi_card__image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Área de interés`
};

const fr_zoi_card__image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Zone d'intérêt`
};

const it_zoi_card__image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Area di interesse`
};

const nl_zoi_card__image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Interessegebied`
};

const pt_zoi_card__image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Área de interesse`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__image_alt = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi_card__image_alt(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi_card__image_alt", locale)
	if (locale === "de") return de_zoi_card__image_alt(inputs)
	if (locale === "en") return en_zoi_card__image_alt(inputs)
	if (locale === "es") return es_zoi_card__image_alt(inputs)
	if (locale === "fr") return fr_zoi_card__image_alt(inputs)
	if (locale === "it") return it_zoi_card__image_alt(inputs)
	if (locale === "nl") return nl_zoi_card__image_alt(inputs)
	return pt_zoi_card__image_alt(inputs)
};